export default {
  trimMe: (str) => {
    const regEx = /(^[\s\xA0]+|[\s\xA0]+$)/g;
    return str.replace(regEx, '');
  },
  testEmail: (email) => {
    const emailRegex = /^([a-zA-Z0-9_.-])+@((([a-zA-Z0-9-])+\.){1,3})([a-zA-Z0-9]{2,6})$/;
    return emailRegex.test(email);
  }
};